import React from 'react'

// Components
import TextInput from 'components/input/TextInput'

// Data
import { payments } from 'utils/constants/data'

function PaymentOption({
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
}) {

    return (
        <div className='bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <p className='uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold'>Payment Option</p>
            <hr className='h-1 border-none text-[#333] bg-[#333]' />
            <p className='text-sm xl:text-base'>Please select your method of payment. Separate correspondence will be issued based on your selection.</p>
            <p className='text-xs md:text-md italic'>At the moment VET Fee Help is not available for any of these qualifications.</p>
            <div className='flex flex-col space-y-4'>
                {payments.map((payment, i) => {
                    return (
                        <div className='flex flex-row items-center space-x-3'>
                            <div>
                                <input
                                    checked={values.payment_option === payment.title}
                                    id={`payment-option-radio-btn-${i}`}
                                    name={`payment-option-${i}`}
                                    type="radio"
                                    onChange={() => setFieldValue(`payment_option`, payment.title)}
                                    value={values.payment_option}
                                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                />
                            </div>
                            <p className='text-base xl:text-lg' key={i}>{payment.title}</p>
                        </div>
                    )
                })}
            </div>
            {(errors?.payment_option && touched?.payment_option) && errors.payment_option && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.payment_option}</p>
            )}
        </div>
    )
}

export default PaymentOption